"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-surface border-border text-text shadow-lg",
          description: "text-muted",
          actionButton: "bg-accent text-white",
          cancelButton: "bg-surface-2 text-muted",
          error: "!bg-destructive/10 !border-destructive/30 !text-destructive",
          success: "!border-accent/30",
        },
      }}
      {...props}
    />
  );
}
